function createFavoritesPlaylistsCardList(dataArray, parentContainer){
    const arr = dataArray;

    arr.map(card => parentContainer.append(createFavoritesPlaylistCardMarkup(card)));
}

function createFavoritesPlaylistCardMarkup(card){
    let formattedDate = moment(card.date).format('ll');
    const baseElement = card.Link != '' && card.Link != false && card.Link != undefined
    ? 'a' : 'div';
    const link = baseElement == 'a' ? `href='${card.Link}'` : '';
    let infoArray = [{"Class": card.Class}, {"Gender": card.Gender}, {"Team": card.Team}];
 
    const cardMarkup = 
    `<${baseElement} class="favorite-training-card js-card active" ${link} data-id='${card.id}'>
        <div class='favorite-training-card__top df fdc gap-4'>
            <div class='fz-15-26 fw-600 c-dark toe pr-32'>${card.Title}</div>
            <div class="df ai-c gap-12">
                <div class='fz-12-16 fw-600 c-orange'>${card.Videos} video${Number(card.Videos) > 1 ? 's' : ''}</div>
                <div class="w-1 h-12 bg-c-gray-3"></div>
                <div class='fz-12-16 fw-600 c-orange'>${formattedDate}</div>
            </div>
            ${card.Favorite ? '<span class="favorite-training-card__favorite js-card-icon-favorite"></span>' : ''}
        </div>
        <div class='h-1 bg-c-gray-2'></div>
        <div class='favorite-training-card__info fz-12-16 fw-600'>
            ${
                infoArray.map(function(item){
                    const layout = 
                    `<div class='c-gray-7'>${Object.keys(item)}:</div>
                    <div class='c-dark'>${item[Object.keys(item)]}</div>`
                    return layout;
                }).join('')
            }
        </div>
    </${baseElement}>`

    return cardMarkup;
}

$(document).ready(function(){
    if ($('.js-favorites-container-playlists').length && favoritesPlaylistsData.length > 0){
        createFavoritesPlaylistsCardList(favoritesPlaylistsData, $('.js-favorites-container-playlists'));
    }
});
